import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import userAPI from "../api/userAPI";
import { useTranslation } from "react-i18next";
import Footer from "../components/Footer";
import { useSelector } from "react-redux";
import { isPartnerClalit } from "../store/partnerStore";

function UserPhoneValidation() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [phone, setPhone] = useState("");
  const [lastName, setLastName] = useState(null);
  const [username, setUsername] = useState("");
  const [continueBtn, setContinueBtn] = useState(true);
  const [smsPayload, setSMSPayload] = useState(null);
  const [displayError, setDisplayError] = useState(false);
  const isClalit = useSelector(isPartnerClalit);

  useEffect(() => {
    if (location?.state) {
      setSMSPayload(location.state);
      setUsername(location.state?.FirstName);
    }
  }, [location.state]);

  const onClickContinue = async () => {
    const payload = { ...smsPayload, Phone: phone };
    if (isClalit && lastName) {
      payload.LastName = lastName.trim();
    }
    const result = await userAPI.sendSmsCode(payload);
    if (result.data.IsPhoneValid) {
      navigate("/otp-validation", { state: payload });
    } else {
      setDisplayError(true);
      setPhone("");
    }
  };

  return (
    <div className="user-phone-validation-container">
      <div className="user-phone-validation-wrapper">
        <div className="user-instruction">
          <span className="username">
            {t("HEY")} {username},
          </span>
          <span className="instruction">{t("PHONE_VALIDATION.TWO_FACTOR_AUTH")}</span>
        </div>

        {isClalit && !location.state?.LastName && (
          <div className="user-inputs">
            <input
              type="text"
              id="lastName"
              name="lastName"
              placeholder={t("PHONE_VALIDATION.LAST_NAME_PLACEHOLDER")}
              className="input"
              style={{ fontSize: "16px" }}
              value={lastName}
              onChange={(e) => {
                setLastName(e.target.value);
                setContinueBtn(e.target.value.trim().length === 0 || phone.length < 10);
              }}
            />
          </div>
        )}

        <div className="user-inputs">
          <input
            type="tel"
            id="phone"
            name="phone"
            placeholder={t("PHONE_VALIDATION.PHONE_PLACEHOLDER")}
            className="input"
            style={{ fontSize: "16px" }}
            value={phone}
            onChange={(e) => {
              setPhone(e.target.value);
              setContinueBtn(e.target.value?.length < 10 || (!location.state?.LastName && (!lastName || lastName.trim().length === 0)));
            }}
          />
          <button className="continue-button" disabled={continueBtn} onClick={() => onClickContinue()}>
            {t("PHONE_VALIDATION.CONTINUE")}
          </button>
          {/* {resendCode && <span className="voice-code">שלחו לי קוד קולי</span>} */}
        </div>

        {displayError && (
          <div className="error-message-container">
            <p className="error-message">{t("PHONE_VALIDATION.PHONE_ERROR_HEADER")}</p>
            <p className="error-message">
              {t("PHONE_VALIDATION.PHONE_ERROR_MESSAGE")}
              <a href="tel:033730300">03-3730300</a>
            </p>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}

export default UserPhoneValidation;
